import {ValidationType} from './ValidationType'

export const PropertyDetailsSentValidation = {
  ContactID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  PropertyID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  UserID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  Response: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Notes: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  Price: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  AddedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  ReviewRequired: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  FeedbackSendRequired: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  FeedbackSentDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  OwnerFeedbackSentDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  LocationRating: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ConditionRating: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  PriceRating: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  }
};
